import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useRef, useState } from "react";
import { editInvestigation } from "services/prosecutorDecipilineService";
import { Complaints, Investigation } from "types";
import { LoadingIcon } from "utils/constant";
import { INVESTIGATION_STATUS } from "utils/constantValues";
import "../styles/AddEvidenceModal.css";

interface ModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  complaintData: Complaints;
  investigationData: Investigation;
  onRefresh: any;
}

export default function UpdateChargeDocModal({
  isOpen,
  setIsOpen,
  complaintData,
  investigationData,
  onRefresh,
}: ModalProps) {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [success, setSuccess] = useState(false);

  const [formState, setFormState] = useState({
    files: [] as File[],
    status: INVESTIGATION_STATUS.FORWARDED_TO_REGISTRAR,
    complaint: null,
  });
  const fileInputRef = useRef<HTMLInputElement>(null);

  // const handleChange = (
  //   e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  // ) => {
  //   const { name, value } = e.target;
  //   setFormState((prev) => ({ ...prev, [name]: value }));
  // };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormState((prev) => ({
        ...prev,
        files: [...Array.from(e.target.files as FileList)],
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    // setError(null);
    // setSuccess(false);

    if (!investigationData) return;

    const data = new FormData();
    data.append("charge_documents", formState?.files[0] || "");
    data.append(
      "assigned_prosecutor",
      complaintData?.user_id_accused_prosecutor_name || ""
    );
    data.append(
      "user_id_assigned_prosecutor",
      complaintData?.user_id_accused_prosecutor_name || ""
    );
    data.append(
      "accused_prosecutor_name",
      complaintData?.accused_prosecutor_name || ""
    );
    data.append(
      "user_id_accused_prosecutor_name",
      complaintData?.user_id_accused_prosecutor_name || ""
    );
    data.append(
      "accused_prosecutor_org_id",
      complaintData?.accused_prosecutor_org_id || ""
    );
    data.append(
      "accused_prosecutor_admin_unit_id",
      complaintData?.accused_prosecutor_admin_unit_id || ""
    );
    data.append("admin_unit_id", complaintData?.admin_unit_id || "");
    data.append("org_id", complaintData?.org_id || "");
    data.append("complaint", String(complaintData?.uu_id));
    data.append("status", formState.status);

    const investigation_id = investigationData?.uu_id || "";
    const isFormData = true;

    try {
      await editInvestigation(data, investigation_id, isFormData);

      onRefresh();
      setIsOpen(false);
      showToast("Successfully Created", "success");
      // setSuccess(true);
      setFormState({
        files: [] as File[],
        complaint: null,
        status: INVESTIGATION_STATUS?.FORWARDED_TO_REGISTRAR,
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast("Submission error", "error");
      // setError(
      // err?.response?.data?.message || err.message || "Something went wrong."
      // );
    } finally {
      setLoading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={"Update Charge Document"}
    >
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Charge File
          </label>
          <div className="file-upload-area" onClick={triggerFileInput}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              // multiple
              style={{ display: "none" }}
            />
            <p className="upload-text">Upload Files</p>
            {formState.files.length > 0 && (
              <div className="file-list">
                {formState.files.map((file, index) => (
                  <div key={index} className="file-item">
                    {file.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              Submitting...
            </div>
          ) : (
            "Update"
          )}
        </button>
      </form>
    </SideModal>
  );
}
